import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { QRCodeComponent } from 'angularx-qrcode';
import domtoimage from 'dom-to-image';

@Component({
  selector: 'app-qr-dialog',
  templateUrl: './qr-dialog.component.html',
  styleUrls: ['./qr-dialog.component.scss']
})
export class QrDialogComponent implements OnInit {

  public value: string;
  constructor(public dialogRef: MatDialogRef<QrDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dataDialog: any) {
        this.value = dataDialog.roadbook.qr_link ? dataDialog.roadbook.qr_link : `https://qr.vectornote.com/${dataDialog.roadbook.id}`;
     }

  ngOnInit(): void {
  }
  cancel(): void {
    this.dialogRef.close();
  }
  saveAsImage(parent: QRCodeComponent) {
    // fetches base 64 date from image
    (domtoimage.toPng(parent.qrcElement.nativeElement) as Promise<any>)
        .then(function (dataUrl: any) {
            const link = document.createElement('a');
            const name = 'Qrcode';
            link.download = `${name}.png`;
            link.href = dataUrl;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            return {result: true, error: null};
        }).catch(error => {
            return {result: false, error: error};
        });
    // const parentElement = parent.qrcElement.nativeElement.querySelector("img").src;

    // // converts base 64 encoded image to blobData
    // const blobData = this.convertBase64ToBlob(parentElement);

    // // saves as image
    // if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) { // IE
    //   (window.navigator as any).msSaveOrOpenBlob(blobData, 'Qrcode');
    // } else { // chrome
    //   const blob = new Blob([blobData], { type: "image/png" });
    //   const url = window.URL.createObjectURL(blob);
    //   // window.open(url);
    //   const link = document.createElement('a');
    //   link.href = url;
    //   link.download = 'Qrcode';
    //   link.click();
    // }

  }

  private convertBase64ToBlob(Base64Image: any) {
    // SPLIT INTO TWO PARTS
    const parts = Base64Image.split(';base64,');
    // HOLD THE CONTENT TYPE
    const imageType = parts[0].split(':')[1];
    // DECODE BASE64 STRING
    const decodedData = window.atob(parts[1]);
    // CREATE UNIT8ARRAY OF SIZE SAME AS ROW DATA LENGTH
    const uInt8Array = new Uint8Array(decodedData.length);
    // INSERT ALL CHARACTER CODE INTO UINT8ARRAY
    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i);
    }
    // RETURN BLOB IMAGE AFTER CONVERSION
    return new Blob([uInt8Array], { type: imageType });
  }

}
